












































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { App } from "@/http/api/v2/supporter/app";
import { AppVersionCreateDto, AppVersionDto, SupportAppVersionSummaryDto } from "@/http/dto/app";

@Component
export default class SupportVersion extends Vue {
  loading = false;
  submitLoading = false;
  deleteLoading = false;
  modalVisible = false;
  errorMessage = "";
  keyword = "";
  current = 1;
  total = 0;
  data: AppVersionDto[] = [];
  summary: SupportAppVersionSummaryDto = { total: 0, mandatoryTotal: 0 };
  selectedVersionObjectId: string | null = null;
  acknowledged = false;
  form: AppVersionCreateDto = { versionCode: "", isMandatory: false };

  rules = {
    versionCode: [
      { required: true, message: "버전을 입력해주세요." },
      { pattern: /^\d+\.\d+\.\d+$/, message: "2.0.41과 같은 형식으로 입력해주세요." },
    ],
  };

  get pagination() {
    return { total: this.total, pageSize: 20, current: this.current, showTotal: (total: number) => `총 ${this.number(total)}개`, showSizeChanger: false };
  }

  get columns() {
    return [
      { title: "버전", dataIndex: "version", width: 320, scopedSlots: { customRender: "version" } },
      { title: "분류", dataIndex: "isMandatory", width: 130, scopedSlots: { customRender: "mandatory" } },
      { title: "등록일", dataIndex: "createdTime", width: 180, scopedSlots: { customRender: "created" } },
      { title: "관리", dataIndex: "actions", width: 100, scopedSlots: { customRender: "actions" } },
    ];
  }

  mounted() { this.load(); }
  number(value: number) { return Number(value || 0).toLocaleString("ko-KR"); }
  dateTime(value: string) { return moment(value).format("YYYY.MM.DD HH:mm"); }
  relativeTime(value: string) { const days = moment().diff(moment(value), "days"); return days < 1 ? "오늘" : days < 30 ? `${days}일 전` : moment(value).format("YYYY.MM.DD"); }
  errorText(error: any, fallback: string) { return (error && error.response && error.response.data && (error.response.data.message || error.response.data.error || error.response.data.Error)) || fallback; }
  search() { this.current = 1; this.load(); }

  async load(pagination?: any) {
    try {
      this.loading = true;
      this.errorMessage = "";
      const current = pagination && pagination.current ? pagination.current : this.current;
      const results = await Promise.all([
        App.getAppVersions({ skip: (current - 1) * 20, take: 20, keyword: this.keyword || undefined }),
        App.getAppVersionSummary(),
      ]);
      this.current = current;
      this.data = Array.isArray(results[0].items) ? results[0].items : [];
      this.total = results[0].total;
      this.summary = results[1];
    } catch (error) {
      this.errorMessage = "앱 버전 정책을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.selectedVersionObjectId = null;
    this.form = { versionCode: "", isMandatory: false };
    this.acknowledged = false;
    this.modalVisible = true;
  }

  openEdit(version: AppVersionDto) {
    this.selectedVersionObjectId = version.objectId;
    this.form = { versionCode: version.versionCode, isMandatory: version.isMandatory };
    this.acknowledged = false;
    this.modalVisible = true;
  }

  closeModal() {
    if (this.submitLoading || this.deleteLoading) return;
    this.modalVisible = false;
    this.selectedVersionObjectId = null;
    this.acknowledged = false;
    this.form = { versionCode: "", isMandatory: false };
  }

  submit() {
    if (!this.acknowledged) { this.$message.warning("고객 영향 확인 항목을 체크해주세요."); return; }
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) return;
      try {
        this.submitLoading = true;
        if (this.selectedVersionObjectId) {
          await App.updateAppVersion(this.selectedVersionObjectId, this.form);
          this.$message.success("앱 버전을 수정했습니다.");
        } else {
          await App.createAppVersion(this.form);
          this.$message.success("앱 버전을 추가했습니다.");
        }
        this.modalVisible = false;
        this.selectedVersionObjectId = null;
        this.acknowledged = false;
        this.form = { versionCode: "", isMandatory: false };
        this.current = 1;
        await this.load();
      } catch (error) {
        this.$message.error(this.errorText(error, "앱 버전을 저장하지 못했습니다."));
      } finally {
        this.submitLoading = false;
      }
    });
  }

  async deleteVersion() {
    if (!this.selectedVersionObjectId) return;
    try {
      this.deleteLoading = true;
      await App.deleteAppVersion(this.selectedVersionObjectId);
      this.$message.success("앱 버전을 삭제했습니다.");
      this.modalVisible = false;
      this.selectedVersionObjectId = null;
      this.acknowledged = false;
      this.form = { versionCode: "", isMandatory: false };
      this.current = 1;
      await this.load();
    } catch (error) {
      this.$message.error(this.errorText(error, "앱 버전을 삭제하지 못했습니다."));
    } finally {
      this.deleteLoading = false;
    }
  }
}
